module.exports = __webpack_public_path__ + "static/media/ceremony.c3f0f426.svg";